export default __webpack_public_path__ + "static/media/icons-r.17117c2d.png";